import accountantsRoutes from "./accountants"

export default [
  ...accountantsRoutes
]